<template>
  <div>
    <h4 class="mb-1">
      {{companyName}}
    </h4>
  </div>
</template>

<script>
import api from "@/api/api-v1-config";

export default {
  name: "CompanyName",

  data() {
    return {
      companyName: ""
    };
  },

  computed: {
  },

  mounted() {
    let conf = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };

     api.get("/tenants/GetTenantDetails", conf)
        .then((response) => {
          if(response.data.result){
            this.companyName = response.data.result.tenant.name;
            //console.log("detailsssss", this.companyName);
          }
        })
    //this.companyName = localStorage.getItem("userTenant");
    //console.log("companyname", localStorage.getItem("userData"));
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.logo-wrapper img {
  width: 180px;
  height: 180px;
}
</style>
